import { createSlice, current } from "@reduxjs/toolkit";

const initialState: any = {
    isLoading: false,
    error: "",
    success: "",
    data: [],
};

export const projectMeetingRedux = createSlice({
    name: 'projectMeetingRedux',
    initialState,
    reducers: {
        // Create a new project meeting
        createProjectMeetingRequest: (state, action) => {
            state.isLoading = true;
        },
        createProjectMeetingSuccess: (state, action) => {
            return {
                ...state,
                isLoading: false,
                success: true,

            }
        },
        createProjectMeetingFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },

        // Read (fetch) all project meetings
        getAllProjectMeetingsRequest: (state) => {
            state.isLoading = true;
        },
        getAllProjectMeetingsSuccess: (state, action) => {
            state.isLoading = false;
            state.data = action.payload.data;
        },
        getAllProjectMeetingsFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },

        // Read (fetch) all project meetings by projectId
        getProjectMeetingsRequest: (state) => {
            state.isLoading = true;
        },
        getProjectMeetingsSuccess: (state, action) => {
            state.isLoading = false;
            state.data = action.payload.data;
        },
        getProjectMeetingsFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },

        // Update a project meeting
        updateProjectMeetingRequest: (state, action) => {
            state.isLoading = true;
        },
        updateProjectMeetingSuccess: (state, action) => {
            state.isLoading = false;
            state.success = "Meeting updated successfully!";
            const index = state.data.findIndex(
                (meeting) => meeting.id === action.payload.id
            );
            if (index !== -1) {
                state.data[index] = action.payload;
            }
        },
        updateProjectMeetingFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },

        // Delete a project meeting
        deleteProjectMeetingRequest: (state, action) => {
            state.isLoading = true;
        },
        deleteProjectMeetingSuccess: (state, action) => {
            state.isLoading = false;
            state.success = "Meeting deleted successfully!";
            state.data = state.data.filter(
                (meeting) => meeting.id !== action.payload
            );
        },
        deleteProjectMeetingFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },

        // Clear errors and success messages
        clearMessages: (state) => {
            state.error = "";
            state.success = "";
            state.data = [];
        },
    },
});

export const {
    createProjectMeetingRequest,
    createProjectMeetingSuccess,
    createProjectMeetingFailure,
    getAllProjectMeetingsRequest,
    getAllProjectMeetingsSuccess,
    getAllProjectMeetingsFailure,
    updateProjectMeetingRequest,
    updateProjectMeetingSuccess,
    updateProjectMeetingFailure,
    deleteProjectMeetingRequest,
    deleteProjectMeetingSuccess,
    deleteProjectMeetingFailure,
    getProjectMeetingsRequest,
    getProjectMeetingsSuccess,
    getProjectMeetingsFailure,
    clearMessages,
} = projectMeetingRedux.actions;

export default projectMeetingRedux.reducer;
